import { LearningGroup } from "@packages/store/models/LearningGroups/LearningGroupModel";

export function filterGroupByLicense(group: LearningGroup) {
  return !group.unlicensed;
}
